import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot,RouterStateSnapshot  } from '@angular/router';
import { DataAccessService } from '../../shared/services/dataaccess.service';
import{RegistrationpopupComponent} from '../../studentportal/components/Registration/registrationpopup.component'
import { Configuration } from './../../app.constants';

export class PortalStudentLogIn
{
  
    StuPoartlaID:number;       
		StudeMailId: string;         
    FirstName:string;  
		LastName:string;       
		StuGender:string;         
		MobileNo:string;        
		Password:string; 
		StudentID:number;     
    PhotoPath:string;
    SignPath:string;
    prospectshow:number;
    ExternalFlag:string;
  Checkflag: string;
  IsAccessible: boolean;
}
export class CollegeDetails
{
  
    CollegeID:number;       
		CollegeName: string;         
    CollegeCode:string;  
    UniversityName:string;
    UniversityNameInDevngari:string;
    ProspectFlag:string;
    ProspectPurchaseFlag:string;

    ContactDetails:string;
    NewRegFlag:string;
    OldRegFlag:string;
    Instructionvideo:string;
    videoflag:string;
}
@Injectable()
export class AuthService {
  loggedIn = false;
  User: any;

  // new
  redirectUrl: string;
  constructor(private dataService: DataAccessService, private Configuration:Configuration,
    private router: Router) {}

 
  forgetPassword(login: string, password: string) {

    this.loggedIn = false;
    this.router.navigate(['/forgetPassword']);
  }
  register(login: string, password: string) {
  
    this.loggedIn = false;
    //this.router.navigate(['/registrationForm']);
   this.router.navigate(['/checklist-registration-info']); 
 
  }

  registerWithPRN(login: string, password: string) {
    this.loggedIn = false; 
   this.router.navigate(['/checklist-registrationwithprn-info']); 
 
  }
  meritlink() {
   this.loggedIn = false; 
   this.router.navigate(['/meritlink']); 
  }
  logOut() {debugger
    this.Configuration.SelectedLanguage="En";
    this.Configuration.LanguageLabel=[];
    this.PostDeleteSystemUserLog(this.Configuration.StuPoartlaID)
    .subscribe(value => {
    },
    err => {
    },
    () => {
    });
    this.loggedIn = false;
    this.router.navigate(['/login-form']);
  }

  get isLoggedIn() {
    return this.loggedIn;
  }

  public logIn(StudeMailId,Password) {
   this.dataService.setControllerName = '/PortalStudentLogIn/';
    this.dataService.setMethodName = 'GetPortalStudentLogin?UserName='+ StudeMailId +'&Password='+ Password ; // setting method name from API controller
   return this.dataService.getAll<PortalStudentLogIn[]>()
  }
  public parentlogIn(StudeMailId,Password) {
    this.dataService.setControllerName = '/PortalStudentLogIn/';
     this.dataService.setMethodName = 'GetPortalParentLogin?UserName='+ StudeMailId +'&Password='+ Password ; // setting method name from API controller
    return this.dataService.getAll<PortalStudentLogIn[]>()
   }
  public GetPdfLink() {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
     this.dataService.setMethodName = 'GetPdfURL'
    return this.dataService.getAll<PortalStudentLogIn[]>()
   }
   public GetPdfLinkForMerit() {
    this.dataService.setControllerName = '/EntPreStudentCourse/';
     this.dataService.setMethodName = 'GetPdfURLForMerit'
    return this.dataService.getAll<PortalStudentLogIn[]>()
   }
   public GetCollegeDetailsForPortal(CollegeURL,CollegeCode) {
    this.dataService.setControllerName = '/BasicCollege/';
     this.dataService.setMethodName = 'GetCollegeDetailsForPortal?CollegeURL=' + CollegeURL + '&CollegeCode=' + CollegeCode + '';
    return this.dataService.getAll<CollegeDetails[]>()
   }
   public GetSystemUniversityForFlag(Flag5) {
    this.dataService.setControllerName = '/SystemUniversity/';
     this.dataService.setMethodName = 'GetSystemUniversityFlagForPortal?FlagName='+Flag5
    return this.dataService.getAll<PortalStudentLogIn[]>()
   }
   public GetPRNNoByStudentID(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
     this.dataService.setMethodName = 'GetPRNNoByStudentID?StudentID='+ StudentID ; 
    return this.dataService.getAll<PortalStudentLogIn[]>()
   }
  public log(navigationExtras,userName){
    
    this.loggedIn = true;
    localStorage.setItem('currentUser',userName);
    debugger;
    //this.router.navigate(['studentportal/courseselectionprospectus']);
    this.router.navigate(['/studentportal/dashboard']);
  }

  public logNewRegistration(navigationExtras,userName){
    debugger;
    this.loggedIn = true;
    localStorage.setItem('currentUser',userName);
    debugger;
    //this.router.navigate(['studentportal/courseselectionprospectus']);
    this.router.navigate(['/studentportal/studentprofile1']);
  }
  public Getusername(){
    return  localStorage.getItem('currentUser');
  }

  public PostDeleteSystemUserLog(StuPoartlaID) {
    this.dataService.setControllerName = '/PortalStudentLogIn/';
     this.dataService.setMethodName = 'PostDeleteSystemUserLogForPortal?StuPoartlaID='; // setting method name from API controller
    return this.dataService.getAllWithCondition<PortalStudentLogIn[]>(StuPoartlaID)

   }
   public GetSystemUserLogByLoginName(LoginName) {debugger
    this.dataService.setControllerName = '/SystemUser/';
     this.dataService.setMethodName = 'GetSystemUserLogByLoginName?LoginName='+ LoginName ; // setting method name from API controller
    return this.dataService.getAll<PortalStudentLogIn[]>()
   }
   public GetSystemUserLogByParentLoginName(LoginName) {debugger
    this.dataService.setControllerName = '/SystemUser/';
     this.dataService.setMethodName = 'GetSystemUserLogByParentLoginName?LoginName='+ LoginName ; // setting method name from API controller
    return this.dataService.getAll<PortalStudentLogIn[]>()
   }
   

   public PostSystemUserAfterLoginForPortal(StudeMailId) {
    this.dataService.setControllerName = '/PortalStudentLogIn/';
     this.dataService.setMethodName = 'GetPostSystemUserAfterLoginForPortal?StudeMailId='; // setting method name from API controller
    return this.dataService.getAllWithCondition<PortalStudentLogIn[]>(StudeMailId)
   }

   public GetCheckUserLoginAccessForPortal(StudeMailId) {debugger
    this.dataService.setControllerName = '/PortalStudentLogIn/';
     this.dataService.setMethodName = 'GetCheckUserLoginAccessForPortal?StudeMailId='+ StudeMailId ; // setting method name from API controller
    return this.dataService.getAll<PortalStudentLogIn[]>()
   }

   public HttpClientInitializeUknowvaHttpClientForStudent(token) {debugger
    this.dataService.setControllerName = '/PortalStudentLogIn/';
     this.dataService.setMethodName = 'HttpClientInitializeUknowvaHttpClientForStudent?token='+ token ; // setting method name from API controller
    return this.dataService.getAll<PortalStudentLogIn[]>()
   }

}

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(private router: Router, private authService: AuthService) {}
    // ,state: RouterStateSnapshot
    canActivate(route: ActivatedRouteSnapshot): boolean {debugger
        const isLoggedIn = this.authService.isLoggedIn;
        const isLoginForm = route.routeConfig.path === 'login-form';
        const isForgetPassword = route.routeConfig.path === 'forgetPassword';
        const isRegistration = route.routeConfig.path === 'registrationForm';
        const isRegistrationWithPRN = route.routeConfig.path === 'studentverifywithprn';

        debugger
        if (isLoggedIn && isLoginForm) {
            this.router.navigate(['/studentportal/dashboard']);
            return false;
        }
        if (isForgetPassword) {

            this.router.navigate(['/forgetPassword']);

        }
        if (isRegistration) {

            this.router.navigate(['/registrationForm']);

        }
        if (isRegistrationWithPRN) {

            this.router.navigate(['/studentverifywithprn']);

        }
        

        if (!isLoggedIn && !isLoginForm) {
            this.router.navigate(['/login-form']);
        }
        // proceeds if not loggedIn or F5/page refresh 

        // Store the attempted URL for redirecting later
        //this.authService.redirectUrl = state.url;
        //alert(state.url);
        //this.router.navigate(['/']);
        //
        // if (!isLoggedIn && !isLoginForm) {
        //     this.router.navigate(['/login-form']);
        // }
        return isLoggedIn || isLoginForm;
    }
}
